"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var http_errors_1 = require("http-errors");

var g = require('loopback/lib/globalize');

exports.createError = function (err) {
  var error = new Error(g.f(err.msg));
  error.code = err.inObject ? err.inObject + "|" + err.code : err.code || 'BAD_REQUEST';
  error.statusCode = err.statusCode || 400;
  return error;
};

exports.isInstanceOfError = function (error) {
  if (error instanceof http_errors_1.HttpError) {
    return true;
  }

  if (error instanceof Error) {
    return true;
  }

  return false;
};

exports.default = exports.createError;